































import {
  defineComponent, ref,
} from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

import { Swipe, SwipeItem } from 'vant';

export type SwiperBanner = {
  imageUrl: string;
  url: string;
  name: string;
  id: string;
};

export default defineComponent({
  name: 'SwiperBanner',
  components: {
    Swipe,
    SwipeItem,
  },
  props: {
    bannerList: {
      type: Array as PropType<SwiperBanner[]>,
      default: () => [],
    },
    autoplay: {
      type: Number,
    },
  },
  emits: ['indicator-change'],
  setup(props, { emit }) {
    const current = ref(0);

    const onBannerChange = (index: number) => {
      current.value = index;
      emit('indicator-change', index);
    };

    return {
      current,
      onBannerChange,
    };
  },

});
